// Export the state object
export default {
  // Store the notification items in an array
  items: []
}
